import { createClient } from '@supabase/supabase-js';

const supabaseUrl = "https://lfwyqlaptpylqywcbzxw.supabase.co";
const supabaseAnonKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imxmd3lxbGFwdHB5bHF5d2Nienh3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzU5OTAxMTcsImV4cCI6MjA1MTU2NjExN30.eb88IxIcPw9DF7xKObtWx_sPnVoZpM9XJdS0Y6AgXjo";

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    flowType: 'pkce'
  },
  global: {
    headers: {
      'Content-Type': 'application/json',
    },
  },
});